/**
 * Utilitaires pour l'encodage/décodage base64 robuste
 * Gère correctement les caractères spéciaux et non-ASCII
 */

/**
 * Encode une chaîne en base64 de manière robuste
 * Gère les caractères spéciaux et non-ASCII correctement
 */
export function encodeBase64(str: string): string {
  // Utiliser TextEncoder pour gérer correctement l'UTF-8
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  
  // Convertir le tableau d'octets en base64
  const base64 = btoa(String.fromCharCode(...new Uint8Array(data)));
  return base64;
}

/**
 * Décode une chaîne base64 de manière robuste
 * Gère les caractères spéciaux et non-ASCII correctement
 */
export function decodeBase64(base64: string): string {
  // Convertir la chaîne base64 en tableau d'octets
  const binString = atob(base64);
  const buf = new Uint8Array(binString.length);
  
  for (let i = 0; i < binString.length; i++) {
    buf[i] = binString.charCodeAt(i);
  }
  
  // Utiliser TextDecoder pour décoder correctement l'UTF-8
  const decoder = new TextDecoder();
  return decoder.decode(buf);
}
